import React from "react"
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks"
import { editAttributes } from "../../../../../services/verifyService/model/verification/VerificationSlice";
import { ReduxUpdate } from "../../../../../utils/ReduxUpdateCommands";
import { Switch } from "@progress/kendo-react-inputs";

function IsCheckOonNotesAttribute(){
    const dispatch = useAppDispatch();
    const verify = useAppSelector((state)=>state.verification.verification);

    const handleChange = (e: any) => {
        dispatch(editAttributes(new ReduxUpdate("isCheckOonNotes", e.target.value)));
    }

    return <React.Fragment>
        <div>
            <label>Check OON Notes</label><br/>
            <Switch name='isCheckOonNotes' value={verify.verifyAttributes.isCheckOonNotes??false}
                checked={verify.verifyAttributes.isCheckOonNotes}
                onChange={handleChange}/>
        </div>
    </React.Fragment>
}
export {IsCheckOonNotesAttribute}
